import React from 'react';

const Footer = () => {
  return (
    <footer className="bg-gradient-to-t from-gray-900 to-gray-800 text-center text-sm text-gray-300 py-6">
      <p className="mb-2 text-gray-400">© 2025 MEMEX - AI. All Rights Reserved.</p>
      <div className="flex flex-wrap justify-center items-center gap-4 text-gray-400">
        <a href="/privacy" className="hover:text-cyan-400 transition duration-200">Privacy Policy</a>
        <span className="text-gray-600">|</span>
        <a href="/terms" className="hover:text-cyan-400 transition duration-200">Terms of Service</a>
        <span className="text-gray-600">|</span>
        <a href="/contact" className="hover:text-cyan-400 transition duration-200">Contact Us</a>
      </div>
    </footer>
  );
};

export default Footer;